import React, { useEffect } from "react";
import { Box, Paper, Tabs, Tab, Stack } from "@mui/material";
import { BlackButton } from "../../Components/Buttons/FiledButton";
import { iconMap } from "@/redux/iconMap";

const CustomTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  buttons = [],
  onButtonClick, // ✅ new prop from parent
}) => {
  const visibleTabs = tabs.filter((tab) => !tab.hide);
  const activeIndex = visibleTabs.findIndex((tab) => tab.id === activeTab);

  useEffect(() => {
    const activeStillVisible = visibleTabs.some((tab) => tab.id === activeTab);
    if (!activeStillVisible && visibleTabs.length > 0) {
      setActiveTab(visibleTabs[0].id); // reset to first visible tab
    }
  }, [tabs, visibleTabs, activeTab, setActiveTab]);

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {" "}
      <Paper
        sx={{
          height: 44,
          display: "flex",
          borderRadius: "10px",
          backgroundColor: "var(--gray-100)",
          boxShadow: "none",
          p: "5px",
          overflow: "hidden",
          alignItems: "center",
          width: "fit-content",
          maxWidth: { md: "100%", lg: "100%", xl: "100%" },
        }}
      >
        <Tabs
          value={activeIndex >= 0 ? activeIndex : 0}
          onChange={(e, newIndex) => {
            const selectedTab = visibleTabs[newIndex];
            setActiveTab(selectedTab?.id);
          }}
          variant="scrollable"
          scrollButtons={false}
          allowScrollButtonsMobile={false}
          sx={{
            mt: "12px",
            "& .MuiTabs-indicator": { display: "none" },
            "& .MuiTabs-flexContainer": {
              borderBottom: "none !important",
            },
            "& .MuiTab-root": {
              maxHeight: 36,
              minHeight: 36,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              color: "var(--gray-600)",
              borderRadius: "8px",
              "&.Mui-selected": {
                color: "var(--brand-800)",
                backgroundColor: "var(--gray-0)",
              },
              "&.Mui-disabled": {
                // Style for disabled tabs
                opacity: 0.5,
                pointerEvents: "none",
              },
            },
          }}
        >
          {visibleTabs.map((tab) => (
            <Tab
              key={tab?.id}
              label={tab?.label}
              disabled={tab?.disabled}
              disableRipple
            />
          ))}
        </Tabs>
      </Paper>
      {/* ✅ Buttons Section (Right Side) */}
      {buttons.length > 0 && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            flexShrink: 0,
            justifyContent: "flex-end",
            flexWrap: "wrap",
          }}
        >
          {buttons.map((button, index) => {
            const Icon = iconMap[button.icon];

            return (
              <BlackButton
                key={`btn-${index}`}
                label={button.label}
                startAdornment={Icon ? <Icon size={20} /> : null}
                onClick={(event) => {
                  if (onButtonClick) onButtonClick(button, event);
                }}
                width="150px"
              />
            );
          })}
        </Stack>
      )}
    </Box>
  );
};

export default CustomTabs;
